import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Order } from './orders.service';

export const QINETIC_POSITION_API_NAME: string = 'qinetic_position';
export const QINETIC_POSITION_API_ENDPOINT: string = environment.API_BASE_PATH + '/qinetic-position';

@Injectable({
  providedIn: 'root',
})
export class QineticPositionService {
  create(order: Order): Observable<any> {
    const api_name: string = QINETIC_POSITION_API_NAME;
    const path: string = `/order/${order.order_id}/store/${order.store_id}`;
    const init = { response: true };
    return from(API.post(api_name, path, init));
  }

  read(qinetic_position_id: string, buyer_id: string): Observable<any> {
    const api_name: string = QINETIC_POSITION_API_NAME;
    const path: string = `/${qinetic_position_id}/buyer/${buyer_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  chargeInstallment(order_id: string, store_id: string, step_id: string): Observable<any> {
    const api_name: string = QINETIC_POSITION_API_NAME;
    const path: string = `/order/${order_id}/store/${store_id}/step/${step_id}`;
    const init = { response: true };
    return from(API.post(api_name, path, init));
  }
}

export class QineticPosition {
  qinetic_position_id?: string;
  qinetic_attachments?: string[];
}
